import * as formActions from "./formActions"
import * as menuActions from "./menuActions"

export default {
    ...formActions,
    ...menuActions
}